module.exports = __webpack_public_path__ + "img/mobi-vtb-logo.18e86541.svg";